import React, { useCallback } from "react";
import { useUscSelector } from "../../../redux/store";
import { CarDeliveryNavStep } from "../../../utils/carDeliveryUtils";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import { UscLabel } from "../../../utils/labels";
import Icon from "../../../../shared-components/toyota/styles/atoms/Icon";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import ModalBaseView from "../../../../shared-components/toyota/styles/organisms/Modal";
import UscCarDeliveryConfigureDestination from "../pdp/car-delivery/UscCarDeliveryConfigureDestination";
import UscCarDeliveryConfigureTransportation from "../pdp/car-delivery/UscCarDeliveryConfigureTransportation";
import * as ModalStyles from "../../../../shared-components/toyota/styles/organisms/Modal.styles";
import { SrOnly } from "../../../../shared-components/toyota/styles/utils/Accessibility.styles";
import * as Styles from "./UscCarDeliveryModal.styles";
import type { UscCarDeliveryModalType } from "../../../utils/modalConstants";

const UscCarDeliveryModal = (props: ModalViewType<UscCarDeliveryModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const navStep = useUscSelector((state) => state.carDelivery.modal.navStep);

    const modalContent = useCallback(() => {
        switch (navStep) {
            case CarDeliveryNavStep.Destination:
                return <UscCarDeliveryConfigureDestination />;
            case CarDeliveryNavStep.Transportation:
                return <UscCarDeliveryConfigureTransportation />;
            default:
                return null;
        }
    }, [navStep]);

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={close}
            size="fillwindow"
            show={show}
            disableOutsideClick
            dialogLabelId="uscBasketDetailsTitle"
            dialogDescId="uscBasketDetailsDesc"
        >
            <ModalStyles.Header>
                <div>
                    <Text id="uscBasketDetailsTitle" tag="h2" variant="h4">
                        <UscLabel label="uscCarDeliveryInfoTitle" />
                    </Text>
                </div>
                <ModalStyles.Button type="button" onClick={close}>
                    <Icon variant="close" />
                    <SrOnly>
                        <UscLabel label="uscCarDeliveryInfoMoreClose" />
                    </SrOnly>
                </ModalStyles.Button>
            </ModalStyles.Header>
            <Styles.Body>{modalContent()}</Styles.Body>
        </ModalBaseView>
    );
};

export default UscCarDeliveryModal;
